(function() {
    function funcReady() {
        var KRP0011 = {
            init: function(){
                var self = this;

                self.setPath();
                self.bindEvents();
            },
            setPath: function(){
                if(dataList != null){
                    //랜탈 탭 일 경우 url에 랜탈탭 파라미터 추가
                    var kiosk = lgkorUI.getParameterByName("kiosk");
                    $(dataList.rentalCompareList).each(function(idx,item){
                        item.modelUrlPath = item.modelUrlPath + "?dpType=careTab";
                        if(kiosk) {
                            item.modelUrlPath += (item.modelUrlPath.indexOf("?") === -1) ? "?" : "&";
                            item.modelUrlPath += 'kiosk='+kiosk;
                        }
                    });
                }
            },
            bindEvents: function() {
                //유사제품 추천(스펙 비교하기)
                $('.KRP0011').on('click', 'button[data-model-ids]', function(e){
                    e.preventDefault();
                    var url = $(this).data('compareUrl');

                    var compareCookie = {};
                    compareCookie[lgePdpSendData.categoryId] = $(this).data('modelIds');

                    lgkorUI.setCookie("LG5_CompareCart_Selected", JSON.stringify(compareCookie));
                    lgkorUI.setCookie("LG5_CompareCart_All", JSON.stringify({}));

                    location.href = url;
                });

                $('.KRP0011').on('click', '.btn-spec-more', function(e){
                    $(this).parent('.btn-spec-wrap').remove();
                    $('.KRP0011').find('.recommend-wrap').addClass('is-spec-full');
                });
            }
        }
        KRP0011.init();
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0011-2.0.0', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0011')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0011')) return false;
        funcReady();
    });
})();